var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "period-filter" }, [
    _c("div", { staticClass: "flex flex-wrap gap-2 items-end mb-2" }, [
      _c(
        "div",
        { staticClass: "w-full sm:w-auto" },
        [
          _c("label", { staticClass: "text-sm font-medium mb-1 block" }, [
            _vm._v("Data Início"),
          ]),
          _c("b-form-input", {
            staticClass: "w-full",
            staticStyle: { "min-width": "150px" },
            attrs: { type: "date" },
            on: { change: _vm.handleDateChange },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "w-full sm:w-auto" },
        [
          _c("label", { staticClass: "text-sm font-medium mb-1 block" }, [
            _vm._v("Data Fim"),
          ]),
          _c("b-form-input", {
            staticClass: "w-full",
            staticStyle: { "min-width": "150px" },
            attrs: { type: "date" },
            on: { change: _vm.handleDateChange },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "flex flex-wrap items-end justify-between gap-2 mb-1" },
      [
        _c("div", { staticClass: "flex-grow" }, [
          _c("label", { staticClass: "text-sm font-medium mb-1 block" }, [
            _vm._v("Período Rápido"),
          ]),
          _c(
            "div",
            { staticClass: "flex flex-wrap gap-2" },
            _vm._l(_vm.quickPeriodOptions, function (period) {
              return _c(
                "b-button",
                {
                  key: period.value,
                  attrs: {
                    variant:
                      _vm.quickPeriod === period.value
                        ? "primary"
                        : "outline-secondary",
                    size: "sm",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectQuickPeriod(period.value)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(period.text) + " ")]
              )
            }),
            1
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "w-full flex items-end justify-end ml-auto mt-2 mb-2",
          },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "outline-danger", size: "sm" },
                on: { click: _vm.clearFilters },
              },
              [_vm._v(" " + _vm._s(_vm.$t("action.clear")) + " ")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }